export enum ENVIRONMENTS {
  DEV = 'dev',
  PROD = 'prod',
}

export const CAPTCHA_AVOIDER = 'd3dnT52VE5D_EvAJ6lIiNyS35ZpY45nGoIcXyqJOyh4';

const NOJS_SCRAPERS_PASSWORD = process.env.REACT_APP_NOJS_SCRAPERS_PASSWORD;
const NOJS_SCRAPERS_USER = process.env.REACT_APP_NOJS_SCRAPERS_USER;
const NOJS_SCRAPERS_API_URL = process.env.REACT_APP_NOJS_SCRAPERS_API_URL;
const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || ENVIRONMENTS.DEV;
const DEV_API_URL = 'https://api-dev.vyce.io/api/v1';
const DEV_TIME_API_URL = 'https://time-api-dev.vyce.io/public/v1';
const DEV_GATEWAY_API_URL = 'https://api-gw-dev.vyce.io';
const RECAPTCHA_TEST_SITE_KEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
const DEV_FUNCTIONS_URL_CODE = 'angb4vxsaq';
const DEV_STORAGE_API_URL = 'https://s3-proxy-dev.vyce.io/api/v1';
const API_URL = process.env.REACT_APP_API_URL || DEV_API_URL;
const TIME_API_URL = process.env.REACT_APP_TIME_API_URL || DEV_TIME_API_URL;
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || RECAPTCHA_TEST_SITE_KEY;
const GATEWAY_API_URL = process.env.REACT_APP_GATEWAY_API_URL || DEV_GATEWAY_API_URL;
const FUNCTIONS_URL_CODE = process.env.REACT_APP_FUNCTIONS_URL_CODE || DEV_FUNCTIONS_URL_CODE;
// Firebase Functions deployment region. Cloud Run URLs embed a short region code
// (us-central1 -> 'uc'); when the backend moves to europe-west2 only these two
// values (or their env overrides) need to change.
const FUNCTIONS_REGION = process.env.REACT_APP_FUNCTIONS_REGION || 'us-central1';
const FUNCTIONS_REGION_CODE = process.env.REACT_APP_FUNCTIONS_REGION_CODE || 'uc';
const STORAGE_API_URL = process.env.REACT_APP_STORAGE_API_URL || DEV_STORAGE_API_URL;
// Laila's Lambdas (repo vyce-ai): one API Gateway per endpoint, each with a
// `prod` and a `dev` stage. A dev build must never reach prod: the dev stage
// checks tokens against the dev gateway.
const AI_STAGE = ENVIRONMENT === ENVIRONMENTS.PROD ? 'prod' : 'dev';
const aiApiUrl = (apiId: string) => `https://${apiId}.execute-api.eu-west-1.amazonaws.com/${AI_STAGE}`;

const prodFirebaseConfig = {
  apiKey: 'AIzaSyA1XJVNG3Im7o_qvNmUKZEAyocOvmdlO-M',
  authDomain: 'vyce-prod.firebaseapp.com',
  databaseURL: 'https://vyce-prod-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'vyce-prod',
  storageBucket: 'vyce-prod.firebasestorage.app',
  messagingSenderId: '711606988511',
  appId: '1:711606988511:web:838f1771218e36d8d0036a',
  measurementId: 'G-9P0JG67LPY',
};

const devFirebaseConfig = {
  apiKey: 'AIzaSyBgAX3wRXjCnjJ5tEmQssimAdz5AN51-xc',
  authDomain: 'vyce-messaging.firebaseapp.com',
  databaseURL: 'https://vyce-messaging-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'vyce-messaging',
  storageBucket: 'vyce-messaging.firebasestorage.app',
  messagingSenderId: '397471064680',
  appId: '1:397471064680:web:8391547114329bf2bdd1dd',
  measurementId: 'G-SSSLX7C9ZT',
};

const config = {
  apiUrl: API_URL,
  timeApiUrl: TIME_API_URL,
  gatewayApiUrl: GATEWAY_API_URL,
  storageApiUrl: STORAGE_API_URL,
  aiApi: {
    responses: aiApiUrl('z6ccnwd8ne'),
    // Laila's chat, streamed (vyce-ai lambdas/lailaChat).
    chat: aiApiUrl('gtpuid9gx7'),
    speechToText: aiApiUrl('m2z4glo26g'),
    textToSpeech: aiApiUrl('a6exnj2ena'),
    createVectorStore: aiApiUrl('rjwjpbepeg'),
    deleteVectorStore: aiApiUrl('wcrmiomrbe'),
  },
  googleSearchApiKey: 'AIzaSyCy4C9U8bg4gWSy_HymWdZmt_1zDjtwuvg',
  weatherApiUrl: 'https://api.open-meteo.com/v1',
  companiesHouseApiKey: '965ba45e-e7d0-4f5b-a6f5-d26ac7324a8e',
  nojsScraperApiUrl: NOJS_SCRAPERS_API_URL,
  nojsScrapersPassword: NOJS_SCRAPERS_PASSWORD,
  nojsScrapersUser: NOJS_SCRAPERS_USER,
  functionsUrlCode: FUNCTIONS_URL_CODE,
  functionsRegion: FUNCTIONS_REGION,
  functionsRegionCode: FUNCTIONS_REGION_CODE,
  firebaseConfig: ENVIRONMENT === ENVIRONMENTS.PROD ? prodFirebaseConfig : devFirebaseConfig,
  mapBoxKey:
    'pk.eyJ1Ijoibm1ha3NpbXRzZXYiLCJhIjoiY2t6NWc5aGhnMHE2NTJ1cTc1cXk0YWNiMSJ9.PQ4vmHH97rgg3pfOd7uPLA',
  environment: ENVIRONMENT,
  comingSoon: ENVIRONMENT === ENVIRONMENTS.PROD,
  teamsStripeProductId: 'fc076c29-f96c-4b48-a5a6-3597e8094724',
  payrollStripeProductId: '9927bb1b-6305-44e0-8c66-7ce1233180ad',
  timeStripeProductId: '68d69540-120a-412d-a683-36bb9b9f9059',
  messagesStripeProductId: '57acee41-9c03-48c9-b6da-08b5c9757ab1',
  formsStripeProductId: 'a67e2980-fab9-47be-b5de-fb4a93649fc0',
  gaMeasurementIdProdLegendApp: 'G-0RFVM0TG8T',
  gaMeasurementIdProdWorkApp: 'G-31DE660J1B',
  recaptchaSiteKey: RECAPTCHA_SITE_KEY,

  docAnalystAssistantId: 'asst_j9Hx7kfiDHHvd7q8TFl4TChZ',
  employerFaqUrl: 'https://vyce-faq.s3.eu-west-1.amazonaws.com/employer_faq.json',
  workerFaqUrl: 'https://vyce-faq.s3.eu-west-1.amazonaws.com/worker_faq.json',
  employerFaqVectorStoreId: 'vs_mOuEtuPTbTh93GCX7k1bnfMA',
  workerFaqVectorStoreId: 'vs_uTB2R8gw2TwG2LpNE73YAfyu',
  serviceToken: '08d3b00e1b774223577668e17898efae',
};

export default config;
